import React, { useState } from 'react';
import './styles.scss';
import { Text } from '../text/Text.tsx';
import { icons } from './icons.ts';
import { GridItem } from './interface.ts';

export const Skills: React.FC = () => {
  const Languages: GridItem[] = [
    { id: 1, icon: icons.objc, title: 'Objective-C' },
    { id: 2, icon: icons.swift, title: 'Swift' },
    { id: 3, icon: icons.java, title: 'Java' },
    { id: 4, icon: icons.ts, title: 'Typescript' },
    { id: 5, icon: icons.js, title: 'Javascript' },
    { id: 6, icon: icons.dart, title: 'Dart' },
  ];
  const platform: GridItem[] = [
    { id: 1, icon: icons.apple, title: 'iOS' },
    { id: 2, icon: icons.android, title: 'Android' },
    { id: 3, icon: icons.rn, title: 'React native' },
    { id: 4, icon: icons.flutter, title: 'Flutter' },
    { id: 5, icon: icons.angular, title: 'Angular' },
    { id: 6, icon: icons.rn, title: 'ReactJS' },
  ];
  const tools: GridItem[] = [
    { id: 1, icon: icons.figma, title: 'Figma' },
    { id: 2, icon: icons.git, title: 'Git' },
    { id: 3, icon: icons.flutter, title: 'Firebase' },
    { id: 4, icon: icons.azure, title: 'Azure' },
  ];

  const [popup, setPopup] = useState<GridItem | null>(null);
  const [selected, setSelected] = useState<number | null>(null);

  return (
    <div className="skills">
      <div className="menu-content">
        <div className="menu">
          <Text style={{ padding: 8, paddingBottom: 0 }} variant="title3">
            {'Languages'}
          </Text>
          {Languages.map((item) => (
            <div key={item.id} className={`menu-item`}>
              <div>
                <img
                  style={{ backgroundColor: 'grey', padding: 2 }}
                  src={item.icon}
                  alt=""
                />
              </div>
              <Text variant="body">{item.title}</Text>
            </div>
          ))}
          <Text style={{ padding: 8, paddingBottom: 0 }} variant="title3">
            {'Platform'}
          </Text>
          {platform.map((item) => (
            <div key={item.id} className={`menu-item`}>
              <div>
                <img
                  style={{ backgroundColor: 'grey', padding: 2 }}
                  src={item.icon}
                  alt=""
                />
              </div>
              <Text variant="body">{item.title}</Text>
            </div>
          ))}
          <Text style={{ padding: 8, paddingBottom: 0 }} variant="title3">
            {'Tools'}
          </Text>
          {tools.map((item) => (
            <div key={item.id} className={`menu-item`}>
              <div>
                <img
                  style={{ backgroundColor: 'grey', padding: 2 }}
                  src={item.icon}
                  alt=""
                />
              </div>
              <Text variant="body">{item.title}</Text>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
